<template>
  <v-card>
    <v-card-title primary-title student="greyk lighten-4k">
      <h4 student="headline mb-0">Enrolled {{ $t("students") }}</h4>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            color="primary"
            @click="showD = !showD"
            student="elevation-5"
            v-on="on"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Enrol new student</span>
      </v-tooltip>

      <v-btn
        color="success"
        @click="showPr = !showPr"
        v-if="settings.ayt && settings.ayt.term.level == 3"
        >Promote Students</v-btn
      >
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        style="max-width: 40%"
      ></v-text-field>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-data-table
        :headers="students_headers"
        :items="students"
        student="elevation-0"
        :search="search"
        :loading="sloading"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td>
            <v-img
              :src="'/images/avatars/' + props.item.s_bio.avatar"
              alt="profile pic"
              lazy-src="../../../../img/user.jpg"
              class="mt-2"
              style="width: 50px; height: 50px; border-radius: 50%"
              v-if="props.item.s_bio.avatar"
            />
            <img
              src="../../../../img/user.jpg"
              alt="profile pic"
              student="mt-2"
              style="width: 50px; height: 50px; border-radius: 50%"
              v-else
            />
          </td>
          <td class="text-xs-center">{{ props.item.s_bio.name }}</td>
          <td class="text-xs-center">{{ props.item.rollno }}</td>
          <td class="text-xs-center">
            {{ props.item.s_bio.email ? props.item.s_bio.email : "N/A" }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.s_guardian
                ? props.item.s_guardian.name +
                  " (" +
                  props.item.s_guardian.phone +
                  ")"
                : "N/A"
            }}
          </td>
          <td class="text-xs-center">
            {{ props.item.s_class ? props.item.s_class.name : "N/A" }}
          </td>

          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn flat icon @click="showPerf(props.item)" v-on="on">
                      <v-icon>bar_chart</v-icon>
                    </v-btn>
                  </template>
                  <span>View student's performance</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs6>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      flat
                      icon
                      color="yellow"
                      @click="attemptSMS(props.item)"
                      v-on="on"
                    >
                      <v-icon>sms</v-icon>
                    </v-btn>
                  </template>
                  <span>Message guardian</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editstudent(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
              <!-- <v-flex xs6 sm3>
                <v-btn flat icon color="blue" @click="showRpt(props.item)">
                  <v-icon>list</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs6 sm3>
                <v-btn flat icon color="blue" @click="showBill(props.item)">
                  <v-icon>money</v-icon>
                </v-btn>
              </v-flex>-->

              <v-flex xs6>
                <v-btn
                  flat
                  icon
                  color="pink"
                  @click="deletestudent(props.item, props.index)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- add-edit student dialog -->
    <m-dialog pers title="Student" :show="showD">
      <template v-slot:header-actions>
        <v-btn @click="showD = !showD" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>

      <template v-slot:content>
        <v-form ref="form">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card class="elevation-2">
                <v-card-title>Student Info</v-card-title>
                <v-divider />
                <v-card-text>
                  <div style="text-align: center">
                    <profile-img
                      field="img"
                      @crop-success="cropSuccess"
                      v-model="showCrop"
                      :width="300"
                      :height="300"
                      img-format="png"
                      langType="en"
                      :noCircle="true"
                    ></profile-img>

                    <v-img
                      v-if="imgDataUrl"
                      :src="imgDataUrl"
                      width="150px"
                      height="150px"
                      style="
                        display: block;
                        margin: 0 auto;
                        border-radius: 10px;
                      "
                    />
                    <v-btn
                      @click="showCrop = !showCrop"
                      color="primary"
                      style="margin-top: 10px; border-radius: 20px"
                      >select image</v-btn
                    >
                  </div>
                  <v-dialog
                    ref="addialog"
                    v-model="admodal"
                    :return-value.sync="student_model.admission_date"
                    persistent
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="student_model.admission_date"
                        label="Admission Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="validRules.required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="student_model.admission_date"
                      scrollable
                    >
                      <div class="flex-grow-1"></div>
                      <v-btn text color="primary" @click="modal = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs.addialog.save(student_model.admission_date)
                        "
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>

                  <v-text-field
                    prepend-icon="keyboard"
                    label="Roll No."
                    hint="enter custom roll no. or leave empty to auto generate one for student"
                    v-model="student_model.rollno"
                  ></v-text-field>
                  <v-text-field
                    label="Name*"
                    prepend-icon="person"
                    v-model="student_model.name"
                    :rules="validRules.required"
                  />
                  <v-text-field
                    label="Email"
                    prepend-icon="email"
                    v-model="student_model.email"
                    :rules="student_model.email ? validRules.email2 : []"
                  />
                  <!-- <v-text-field label="Phone" prepend-icon="phone" v-model="student_model.phone" />
                   -->
                  <v-dialog
                    ref="dobdialog"
                    v-model="dobmodal"
                    :return-value.sync="student_model.dob"
                    persistent
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="student_model.dob"
                        label="Date of Birth*"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="validRules.required"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="student_model.dob" scrollable>
                      <div class="flex-grow-1"></div>
                      <v-btn text color="primary" @click="modal = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dobdialog.save(student_model.dob)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                  <v-select
                    label="Blood Group"
                    prepend-icon="opacity"
                    :items="['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-']"
                    v-model="student_model.blood_group"
                  />
                  <v-autocomplete
                    label="Class*"
                    :items="classes"
                    :loading="cloading"
                    item-text="name"
                    item-value="id"
                    prepend-icon="border_all"
                    v-model="student_model.class_id"
                    :rules="validRules.required"
                  />
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card style="margin-top: 10px" class="elevation-2">
                <v-card-title>Parents/Guardian Info</v-card-title>
                <v-divider />
                <v-card-text>
                  <v-text-field
                    label="Father Name*"
                    v-model="student_model.father_name"
                    :rules="validRules.required"
                  />
                  <v-text-field
                    label="Father Phone*"
                    v-model="student_model.father_phone"
                    :rules="validRules.required"
                  />
                  <v-text-field
                    label="Father Occupation"
                    v-model="student_model.father_occupation"
                  />
                  <v-text-field
                    label="Mother Name*"
                    v-model="student_model.mother_name"
                    :rules="validRules.required"
                  />
                  <v-text-field
                    label="Mother Phone*"
                    v-model="student_model.mother_phone"
                    :rules="validRules.required"
                  />
                  <v-text-field
                    label="Mother Occupation"
                    v-model="student_model.mother_occupation"
                  />

                  <v-autocomplete
                    label="Guardian"
                    :items="guardians"
                    :loading="gloading"
                    item-text="name"
                    item-value="id"
                    v-model="student_model.guardian_id"
                    :clearable="true"
                  >
                    <template v-slot:append-outer>
                      <v-btn icon color="primary" @click="showG = !showG">
                        <v-icon>add</v-icon>
                      </v-btn>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </template>

      <template v-slot:footer-actions>
        <v-btn style="cursor: pointer" color="success" @click="savestudent()"
          >save</v-btn
        >
        <v-btn @click="showD = !showD" style="cursor: pointer" color="error"
          >close</v-btn
        >
      </template>
    </m-dialog>

    <!-- student performance dialog -->
    <m-dialog pers title="Student Performance" :show="showP">
      <template v-slot:header-actions>
        <v-autocomplete
          label="Academic Year"
          :items="acyears"
          item-text="year"
          item-value="id"
          v-model="pr_acyear_id"
        ></v-autocomplete>
        <v-btn @click="showP = !showP" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <div>
          <s-perf
            :student_details="selected_student"
            :acyear="pr_acyear_id"
          ></s-perf>
        </div>
      </template>

      <template v-slot:footer-actions>
        <v-btn
          style="cursor: pointer"
          color="success"
          icon
          @click="printPerfStats('perf')"
        >
          <v-icon>print</v-icon>
        </v-btn>
      </template>
    </m-dialog>

    <!-- student Bill dialog -->
    <m-dialog pers title="Student Bill" :show="showB">
      <template v-slot:header-actions>
        <v-btn @click="showB = !showB" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <div>
          <s-bill :student_details="selected_student"></s-bill>
        </div>
      </template>

      <template v-slot:footer-actions>
        <v-btn
          style="cursor: pointer"
          color="success"
          icon
          @click="print('bill')"
        >
          <v-icon>print</v-icon>
        </v-btn>
      </template>
    </m-dialog>

    <!-- student Academic Report dialog -->
    <m-dialog pers title="Student Report" :show="showR">
      <template v-slot:header-actions>
        <v-btn @click="showR = !showR" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <div>
          <report-card :student_details="selected_student"></report-card>
        </div>
      </template>

      <template v-slot:footer-actions>
        <v-btn
          style="cursor: pointer"
          color="success"
          icon
          @click="print('rptcard')"
        >
          <v-icon>print</v-icon>
        </v-btn>
      </template>
    </m-dialog>

    <!-- student guardian text message dialog -->
    <m-dialog pers title="Message Guardian" :show="showM">
      <template v-slot:header-actions>
        <v-btn @click="showM = !showM" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <h5>Student: {{ selected_student.s_bio.name }}</h5>
        <v-form ref="msgForm">
          <v-text-field
            readonly
            label="Guardian:"
            :value="
              selected_student.s_guardian
                ? selected_student.s_guardian.name +
                  ' (' +
                  selected_student.s_guardian.phone +
                  ')'
                : ''
            "
          ></v-text-field>
          <v-textarea
            filled
            outline
            auto-grow
            label="Message"
            rows="4"
            row-height="30"
            shaped
            v-model="msg"
            :rules="validRules.required"
          ></v-textarea>
        </v-form>
      </template>

      <template v-slot:footer-actions>
        <v-btn
          style="cursor: pointer"
          color="success"
          @click="sendMessage()"
          :loading="smloading"
          >send</v-btn
        >
        <v-btn @click="showM = !showM" style="cursor: pointer" color="error"
          >close</v-btn
        >
      </template>
    </m-dialog>

    <!-- student guardian add dialog -->
    <m-dialog pers title="Add Guardian" :show="showG">
      <template v-slot:header-actions>
        <v-btn @click="showG = !showG" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>

      <template v-slot:content>
        <v-form ref="grdForm">
          <v-card>
            <v-card-text>
              <v-radio-group v-model="guardianInfRadioGroup" row>
                <v-radio
                  label="Enter Guardian Information"
                  value="enter_inf"
                ></v-radio>
                <v-radio
                  label="Use Father's Information"
                  value="father_inf"
                ></v-radio>
                <v-radio
                  label="Use Mother's Information"
                  value="mother_inf"
                ></v-radio>
              </v-radio-group>
              <v-text-field
                label="Name"
                v-model="guardian_model.name"
                :rules="validRules.required"
              />
              <v-text-field
                label="Email"
                v-model="guardian_model.email"
                :rules="validRules.email"
              />
              <v-text-field
                label="Phone"
                v-model="guardian_model.phone"
                :rules="validRules.required"
              />
              <v-text-field
                type="password"
                label="Password"
                v-model="guardian_model.password"
                :rules="validRules.password"
              />
            </v-card-text>
          </v-card>
          <!-- <v-text-field label="Photo" v-model="guardian_model.avatar" /> -->
        </v-form>
      </template>

      <template v-slot:footer-actions>
        <v-btn
          style="cursor: pointer"
          color="success"
          @click="addguardian()"
          :loading="gloading"
          >save</v-btn
        >
        <v-btn @click="showG = !showG" style="cursor: pointer" color="error"
          >close</v-btn
        >
      </template>
    </m-dialog>

    <!-- student guardian text message dialog -->
    <m-dialog pers title="Promotion" :show="showPr">
      <template v-slot:header-actions>
        <v-btn @click="showPr = !showPr" icon style="cursor: pointer">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <template v-slot:content>
        <v-form>
          <promo :trigpromo="showPr"></promo>
        </v-form>
      </template>

      <!-- <template v-slot:footer-actions>
        <v-btn
          style="cursor:pointer"
          color="success"
          @click="sendMessage()"
          :loading="smloading"
        >send</v-btn>
        <v-btn @click="showM=!showM" style="cursor:pointer" color="error">close</v-btn>
      </template>-->
    </m-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../../../components/Modal";
import SPerformance from "../../../components/student/performanceStats";
import SBill from "../../../components/student/bill";
import RCard from "../../../components/student/reportCard";
import promo from "../../../components/student/promotion";
import profileImg from "vue-image-crop-upload";
export default {
  name: "students-view",
  components: {
    "m-dialog": Modal,
    "s-perf": SPerformance,
    "s-bill": SBill,
    "report-card": RCard,
    profileImg,
    promo,
  },
  metaInfo() {
    return { title: this.$t("students") };
  },
  data() {
    return {
      showD: false,
      showP: false,
      showM: false,
      showG: false,
      showR: false,
      showB: false,
      showPr: false,
      admodal: false,
      dobmodal: false,
      site_online: false,
      img: false,
      showCrop: false,
      imgDataUrl: "",
      search: "",
      editedIndex: -1,
      pr_acyear_id: 0,
      ackey: 0,
      grd_num: null,
      msg: "",
      sms_senderid: "",
      sms_apiKey: "",
      guardianInfRadioGroup: "enter_inf",
      selected_student: {
        rollno: "",
        s_bio: {
          name: "",
        },
        s_class: {
          name: "",
        },
        s_guardian: {
          name: "",
        },
      },
      student_model: {
        admission_date: new Date().toISOString().substr(0, 10),
        name: "",
        email: "",
        phone: "",
        password: "password",
        dob: "",
        blood_group: "",
        avatar: "",
        avatar_data: "",
        roles: ["student"],
        class_id: "",
        father_name: "",
        father_phone: "",
        father_occupation: "",
        mother_name: "",
        mother_phone: "",
        mother_occupation: "",
        guardian_id: "",
      },
      guardian_model: {
        name: "",
        phone: "",
        email: "",
        password: "",
        avatar: "",
      },
      guardian_modelcp: {
        name: "",
        phone: "",
        email: "",
        password: "",
        avatar: "",
      },

      student_modelcp: {
        admission_date: new Date().toISOString().substr(0, 10),
        name: "",
        email: "",
        password: "password",
        phone: "",
        dob: "",
        blood_group: "",
        avatar: "",
        avatar_data: "",
        roles: ["student"],
        class_id: "",
        father_name: "",
        father_phone: "",
        father_occupation: "",
        mother_name: "",
        mother_phone: "",
        mother_occupation: "",
        guardian_id: "",
      },
      students_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "sn",
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "student",
        },
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "s_bio.name",
        },
        {
          text: "Std. ID",
          align: "center",
          sortable: true,
          value: "rollno",
        },
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email",
        },
        {
          text: "Guardian",
          align: "center",
          sortable: true,
          value: "s_guardian.name",
        },
        {
          text: "Class",
          align: "center",
          sortable: true,
          value: "s_class.name",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "s_guardian.phone",
        },
      ],
    };
  },
  mounted() {
    this.site_online = navigator.onLine ? true : false;
    this.$store.dispatch("students/getAll");
    this.$store.dispatch("classes/getAll");
    this.$store.dispatch("guardians/getAll");
    this.$store.dispatch("academicYear/getAll");

    this.$store.dispatch("settings/getAll");

    this.sms_senderid = this.settings.sms ? this.settings.sms.senderid : "";
    this.sms_apiKey = this.settings.sms ? this.settings.sms.apiKey : "";

    if (this.site_online) {
      //console.log("yaaaat",this.sms_apiKey)
      this.$store.dispatch("sms/getBalance", this.sms_apiKey);
    }
  },
  computed: {
    ...mapGetters({
      students: "students/STUDENTS",
      sterrors: "students/STUDENT_ERROR",
      sloading: "students/STUDENT_LOADING",

      classes: "classes/CLASSES",
      cloading: "classes/CLASS_LOADING",

      guardians: "guardians/GUARDIANS",
      gloading: "guardians/GUARDIAN_LOADING",
      gerrors: "guardians/GUARDIAN_ERROR",

      acyears: "academicYear/ACYEARS",
      ayerrors: "academicYear/ACYEAR_ERROR",
      loading: "academicYear/ACYEAR_LOADING",

      settings: "settings/SETTINGS",
      sms_balance: "sms/SMS_BALANCE",
      smerrors: "sms/SMS_ERROR",
      smloading: "sms/SMS_LOADING",
    }),
  },
  methods: {
    toggle(n) {
      this.window = n;
    },
    cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
      this.student_model.avatar_data = imgDataUrl;
    },

    attemptSMS(sel_std) {
      this.selected_student = sel_std;
      this.grd_num = sel_std.s_guardian ? sel_std.s_guardian.phone : null;

      // alert(this.grd_num);
      this.showM = true;
    },
    sendMessage() {
      if (!this.$refs.msgForm.validate()) {
        return;
      }
      if (!this.site_online) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry, message could not be sent. Please check your network.",
          title: "SMS",
          modal: false,
        });

        return;
      }

      if (this.sms_balance < 1) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text:
            "Sorry, there is insufficient balance to send this message, please inform administrator to reacharge sms account.",
          title: "SMS",
          modal: false,
        });

        return;
      }

      if (this.grd_num == null || this.grd_num == "") {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text:
            "Sorry and error occured,guardian has no phone number set to receive sms.",
          title: "SMS",
          modal: false,
        });

        return;
      }

      this.$store.dispatch("sms/send", {
        key: this.sms_apiKey,
        to: this.grd_num,
        msg: this.msg,
        senderid: this.sms_senderid,
      });

      if (this.smerrors == null) {
        this.$store.dispatch("sms/getBalance", this.sms_apiKey);
        this.msg = "";
        this.rcpts_model = "";
        this.grd_num = "";

        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Message sent successfully.",
          title: "SMS",
          modal: false,
        });
      } else {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry,an error occured and message could not be sent.",
          title: "SMS",
          modal: false,
        });
      }
    },
    addguardian() {
      if (!this.$refs.grdForm.validate()) {
        return;
      }
      this.$store.dispatch("guardians/add", this.guardian_model);

      if (this.gerrors == null) {
        this.showG = false;
        this.guardian_model = this.guardian_modelcp;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Guardian added successfully.",
          title: "Guardian",
          modal: false,
        });
      }
    },

    printPerfStats(doc) {
      //different print method because it has charts in it

      //console.log(prtHtml)

      let lc_canvas = document.getElementById("line-chart");
      let bc_canvas = document.getElementById("bar-chart");
      if (lc_canvas.outerHTML || bc_canvas.outerHTML) {
        let lc_img =
          "<img src='" +
          lc_canvas.toDataURL() +
          "' style='height: 100%; width: 100%; object-fit: contain'/>";
        let bc_img =
          "<img src='" +
          bc_canvas.toDataURL() +
          "' style='height: 100%; width: 100%; object-fit: contain'/>";

        lc_canvas.outerHTML = lc_img;
        bc_canvas.outerHTML = bc_img;
      }

      // Get HTML to print from element
      const prtHtml = document.getElementById(doc).innerHTML;

      this.showP = !this.showP;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      var toPrint = `<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`;

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(toPrint);

      WinPrint.document.close();
      WinPrint.focus();

      if (WinPrint.document.readyState === "complete") {
        setTimeout(function () {
          WinPrint.print();
          WinPrint.close();
        }, 1300);
      }
    },
    print(doc) {
      // Get HTML to print from element
      const prtHtml = document.getElementById(doc).innerHTML;
      //console.log(prtHtml)

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      var toPrint = `<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`;

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(toPrint);

      WinPrint.document.close();
      WinPrint.focus();

      if (WinPrint.document.readyState === "complete") {
        // setTimeout(function(){
        //    WinPrint.print();
        //    WinPrint.close();
        //   }, 1300);
      }
    },

    print2() {
      const d = new Printd();
      d.print(this.$el, this.cssText, (win, doc, node, launchPrint) => {
        // Get style elements
        const styles = [].slice.call(document.getElementsByTagName("style"));
        // append them to the the new document head element
        styles.forEach((styleElement) =>
          doc.head.appendChild(styleElement.cloneNode(true))
        );
        launchPrint(win);
      });
    },
    showPerf(std) {
      this.selected_student = std;
      this.showP = !this.showP;
    },

    showRpt(std) {
      this.selected_student = std;
      this.showR = !this.showR;
    },

    showBill(std) {
      this.selected_student = std;
      this.showB = !this.showB;
    },
    addstudent() {
      console.log(this.student_model);
      this.$store.dispatch("students/add", this.student_model);

      if (this.sterrors == null) {
        let c = this.student_model.avatar_data;
        this.student_model = {
          admission_date: new Date().toISOString().substr(0, 10),
          roles: ["student"],
          password: "password",
          phone: "",
        };
        this.imgDataUrl = "";
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Student enrolled successfully.",
          title: "Student",
          modal: false,
        });
        if (c) {
          setTimeout(() => {
            window.location.reload();
          }, 200);
        }
      }
    },
    deletestudent(student, index) {
      if (confirm("Are you sure you want to delete this student?")) {
        let idx = this.students.indexOf(student);
        this.$store.dispatch("students/delete", { student, index: idx });
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Student deleted successfully.",
          title: "Student",
          modal: false,
        });
      }
    },

    editstudent(student) {
      this.editedIndex = this.students.indexOf(student);
      this.student_model = Object.assign({}, student);

      this.student_model.name = student.s_bio.name;
      this.student_model.email = student.s_bio.email;
      this.student_model.phone = student.s_bio.phone;
      this.student_model.password = student.s_bio.password;
      this.student_model.roles = ["student"];
      this.student_model.avatar = student.s_bio.avatar;

      this.imgDataUrl = this.student_model.avatar
        ? "/images/avatars/" + this.student_model.avatar
        : "../../../../img/user.jpg";

      //alert(this.editedIndex)

      this.showD = true;
    },
    updatestudent(student, index) {
      this.$store.dispatch("students/update", { index, student });

      if (this.sterrors == null) {
        let c = this.student_model.avatar_data;
        this.student_model = {
          admission_date: new Date().toISOString().substr(0, 10),
          roles: ["student"],
          password: "password",
        };
        this.editedIndex = -1;
        this.showD = false;
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "Student details updated successfully.",
          title: "Student",
          modal: false,
        });
        if (c) {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      }
    },
    savestudent() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing student info or saving student info
      if (this.editedIndex > -1) {
        this.updatestudent(this.student_model, this.editedIndex);
      } else {
        this.addstudent();
      }
    },

    student_teacher_name(tid) {
      let c = this.teachers.filter((t) => {
        return t.id === tid;
      });

      return c[0].name;
    },
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.student_model = {
          admission_date: new Date().toISOString().substr(0, 10),
          roles: ["student"],
          password: "password",
        };
      }
    },
    showPr(val) {
      if (val == false) {
        this.$store.dispatch("students/getAll");
      } else {
        this.$store.dispatch("students/getAll");
      }
    },
    showG(val) {
      if (val == false) {
        this.guardianInfRadioGroup = "enter_inf";
        Object.assign(this.guardian_model, this.guardian_modelcp);
      }
    },
    guardianInfRadioGroup(val) {
      if (val == "father_inf") {
        this.guardian_model.name = this.student_model.father_name;
        this.guardian_model.phone = this.student_model.father_phone;
        this.guardian_model.password = this.student_model.father_phone;
      } else if (val == "mother_inf") {
        this.guardian_model.name = this.student_model.mother_name;
        this.guardian_model.phone = this.student_model.mother_phone;
        this.guardian_model.password = this.student_model.mother_phone;
      } else {
        Object.assign(this.guardian_model, this.guardian_modelcp);
      }
    },
  },
};
</script>






// WEBPACK FOOTER //
// resources/assets/js/pages/admin/students/students.vue